// import React, { useEffect } from "react";
// import {
//     Box, Typography, Button, CircularProgress, TextField, MenuItem,
//     Select, Checkbox, Dialog, DialogTitle, DialogContent,
//     DialogActions, IconButton
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from "@mui/icons-material/Close";

// const NAVY     = "#0D2137";
// const STEEL    = "#1B4FBB";
// const STEEL_LT = "#EBF2FF";
// const PAGE_BG  = "#F4F6F9";
// const CARD     = "#FFFFFF";
// const BORDER   = "#E2E8F0";
// const TH_BG    = "#F7F9FC";
// const T1       = "#1A202C";
// const T2       = "#4A5568";
// const T3       = "#718096";
// const WHITE    = "#FFFFFF";

// const btnPrimary = {
//     background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
//     textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
//     "&:hover": { background: "#1640A0" },
//     "&:disabled": { background: BORDER, color: T3 },
// };
// const btnGhost = {
//     color: T2, border: `1px solid ${BORDER}`, background: "transparent",
//     borderRadius: "4px", fontSize: 12, fontWeight: 500, textTransform: "none",
//     px: 1.5, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: PAGE_BG, color: T1 },
// };
// const inputSx = {
//     "& .MuiOutlinedInput-root": {
//         borderRadius: "4px", background: CARD, fontSize: 13,
//         "& fieldset": { borderColor: BORDER },
//         "&:hover fieldset": { borderColor: STEEL },
//         "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//     },
// };

// export default function OSandODSaleFilterDialog({
//     open, onClose, allClients,
//     tempFromDate, setTempFromDate,
//     tempToDate, setTempToDate,
//     tempClientSearchText, setTempClientSearchText,
//     tempSelectedClients, setTempSelectedClients,
//     filteredTempClients, handleTempClientCheckbox,
//     loading, onGetData,
//     reportType, setReportType,
// }) {
//     useEffect(() => {
//         if (open) { setTempClientSearchText(""); setTempSelectedClients([]); }
//     }, [reportType]);

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
//             PaperProps={{ sx: { borderRadius: "6px", border: `1px solid ${BORDER}`, boxShadow: "0 12px 40px rgba(0,0,0,0.18)", overflow: "hidden" } }}>

//             {/* Dialog Header — dark navy */}
//             <DialogTitle sx={{ p: 0 }}>
//                 <Box sx={{ background: NAVY, px: 2.5, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box>
//                         <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>Report Configuration</Typography>
//                         <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "3px" }}>Set parameters to generate the sale bills report</Typography>
//                     </Box>
//                     <IconButton onClick={onClose} size="small"
//                         sx={{ color: "rgba(255,255,255,0.6)", "&:hover": { background: "rgba(255,255,255,0.1)" } }}>
//                         <CloseIcon sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </DialogTitle>

//             <DialogContent sx={{ px: 2.5, py: 2.5, background: WHITE }}>
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

//                     {/* Report Type */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Report Type</Typography>
//                         <Select fullWidth size="small" value={reportType} onChange={(e) => setReportType(e.target.value)}
//                             sx={{ borderRadius: "4px", fontSize: 13, "& fieldset": { borderColor: BORDER }, "&:hover fieldset": { borderColor: STEEL }, "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 } }}>
//                             <MenuItem value="sale-outstanding">Sale Outstanding Bills</MenuItem>
//                             <MenuItem value="sale-overdue">Sale Overdue Bills</MenuItem>
//                         </Select>
//                     </Box>

//                     {/* Date Range */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Date Range</Typography>
//                         <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, color: T2, mb: "4px", fontWeight: 500 }}>From</Typography>
//                                 <TextField type="date" fullWidth size="small" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
//                             </Box>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, color: T2, mb: "4px", fontWeight: 500 }}>To</Typography>
//                                 <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
//                             </Box>
//                         </Box>
//                     </Box>

//                     {/* Client Selection */}
//                     <Box>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>
//                             Clients &nbsp;
//                             <Typography component="span" sx={{ fontSize: 11, color: T2, fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>
//                                 ({tempSelectedClients.length} of {allClients.length} selected)
//                             </Typography>
//                         </Typography>
//                         <TextField fullWidth size="small" placeholder="Search clients…" value={tempClientSearchText}
//                             onChange={(e) => setTempClientSearchText(e.target.value)} sx={{ ...inputSx, mb: 1 }}
//                             InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T3, fontSize: 16 }} /> }} />
//                         <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "4px", overflow: "hidden", maxHeight: 220, overflowY: "auto" }}>
//                             {/* Select All header */}
//                             <Box sx={{ display: "flex", alignItems: "center", px: 1.5, py: "7px", background: TH_BG, borderBottom: `1px solid ${BORDER}`, position: "sticky", top: 0, zIndex: 1 }}>
//                                 <Checkbox size="small"
//                                     checked={tempSelectedClients.length === filteredTempClients.length && filteredTempClients.length > 0}
//                                     indeterminate={tempSelectedClients.length > 0 && tempSelectedClients.length < filteredTempClients.length}
//                                     onChange={() => {
//                                         if (tempSelectedClients.length === filteredTempClients.length) setTempSelectedClients([]);
//                                         else setTempSelectedClients([...tempSelectedClients, ...filteredTempClients.filter(c => !tempSelectedClients.some(s => s.id === c.id))]);
//                                     }}
//                                     sx={{ color: T3, "&.Mui-checked": { color: STEEL }, "&.MuiCheckbox-indeterminate": { color: STEEL }, p: "3px" }} />
//                                 <Typography sx={{ fontSize: 12, fontWeight: 600, color: T2 }}>Select All ({filteredTempClients.length})</Typography>
//                             </Box>
//                             {filteredTempClients.length === 0 ? (
//                                 <Box sx={{ py: 3, textAlign: "center" }}>
//                                     <Typography sx={{ fontSize: 13, color: T3 }}>No clients found</Typography>
//                                 </Box>
//                             ) : filteredTempClients.map((client) => {
//                                 const isSelected = tempSelectedClients.some(c => c.id === client.id);
//                                 return (
//                                     <Box key={client.id} onClick={() => handleTempClientCheckbox(client)}
//                                         sx={{ display: "flex", alignItems: "center", px: 1.5, py: "6px", cursor: "pointer", borderBottom: `1px solid ${BORDER}`, background: isSelected ? STEEL_LT : WHITE, "&:hover": { background: STEEL_LT } }}>
//                                         <Checkbox size="small" checked={isSelected} onChange={() => handleTempClientCheckbox(client)} onClick={(e) => e.stopPropagation()}
//                                             sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "3px", mr: 0.5 }} />
//                                         <Typography sx={{ fontSize: 13, color: T1, fontWeight: isSelected ? 600 : 400 }}>{client.FirmName}</Typography>
//                                     </Box>
//                                 );
//                             })}
//                         </Box>
//                     </Box>
//                 </Box>
//             </DialogContent>

//             <DialogActions sx={{ px: 2.5, py: 2, gap: 1, borderTop: `1px solid ${BORDER}`, background: TH_BG }}>
//                 <Button onClick={onClose} fullWidth sx={{ ...btnGhost, height: 34 }}>Cancel</Button>
//                 <Button onClick={onGetData} fullWidth disabled={loading || tempSelectedClients.length === 0}
//                     startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
//                     sx={{ ...btnPrimary, height: 34 }}>
//                     Generate Report
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// }






import React, { useEffect } from "react";
import {
    Box, Typography, Button, CircularProgress, TextField, MenuItem,
    Select, Checkbox, Dialog, DialogTitle, DialogContent,
    DialogActions, IconButton
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const NAVY     = "#0D2137";
const STEEL    = "#1B4FBB";
const STEEL_LT = "#EBF2FF";
const PAGE_BG  = "#F4F6F9";
const CARD     = "#FFFFFF";
const BORDER   = "#E2E8F0";
const TH_BG    = "#F7F9FC";
const T1       = "#1A202C";
const T2       = "#4A5568";
const T3       = "#718096";
const WHITE    = "#FFFFFF";

const btnPrimary = {
    background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
    textTransform: "none", px: 2, height: 32, whiteSpace: "nowrap",
    "&:hover": { background: "#1640A0" },
    "&:disabled": { background: BORDER, color: T3 },
};
const btnGhost = {
    color: T2, border: `1px solid ${BORDER}`, background: "transparent",
    borderRadius: "4px", fontSize: 12, fontWeight: 500, textTransform: "none",
    px: 1.5, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: PAGE_BG, color: T1 },
};
const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "4px", background: CARD, fontSize: 13,
        "& fieldset": { borderColor: BORDER },
        "&:hover fieldset": { borderColor: STEEL },
        "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
    },
};

export default function OSandODSaleFilterDialog({
    open, onClose, allClients,
    tempFromDate, setTempFromDate,
    tempToDate, setTempToDate,
    tempAsOnDate, setTempAsOnDate,
    tempClientSearchText, setTempClientSearchText,
    tempSelectedClients, setTempSelectedClients,
    filteredTempClients, handleTempClientCheckbox,
    loading, onGetData,
    reportType, setReportType,
}) {
    useEffect(() => {
        if (open) { setTempClientSearchText(""); setTempSelectedClients([]); }
    }, [reportType]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: "6px", border: `1px solid ${BORDER}`, boxShadow: "0 12px 40px rgba(0,0,0,0.18)", overflow: "hidden" } }}>

            {/* Dialog Header — dark navy */}
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ background: NAVY, px: 2.5, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box>
                        <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>Report Configuration</Typography>
                        <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: "3px" }}>Set parameters to generate the sale bills report</Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small"
                        sx={{ color: "rgba(255,255,255,0.6)", "&:hover": { background: "rgba(255,255,255,0.1)" } }}>
                        <CloseIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ px: 2.5, py: 2.5, background: WHITE }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

                    {/* Report Type */}
                    <Box>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>Report Type</Typography>
                        <Select disabled fullWidth size="small" value={reportType} onChange={(e) => setReportType(e.target.value)}
                            sx={{ borderRadius: "4px", fontSize: 13, "& fieldset": { borderColor: BORDER }, "&:hover fieldset": { borderColor: STEEL }, "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 } }}>
                            <MenuItem value="sale-outstanding">Sale Outstanding Bills</MenuItem>
                            <MenuItem value="sale-overdue">Sale Overdue Bills</MenuItem>
                        </Select>
                    </Box>

                    {/* Date Range */}
                    <Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "6px" }}>
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".5px" }}>Date Range</Typography>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Checkbox size="small" checked={tempAsOnDate} onChange={(e) => setTempAsOnDate(e.target.checked)}
                                    sx={{ color: T3, "&.Mui-checked": { color: STEEL }, p: "3px" }} />
                                <Typography sx={{ fontSize: 11, color: T2, fontWeight: 500 }}>As On Date</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
                            <Box>
                                <Typography sx={{ fontSize: 11, color: T2, mb: "4px", fontWeight: 500 }}>From</Typography>
                                <TextField type="date" fullWidth size="small" disabled={tempAsOnDate} value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} sx={inputSx} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 11, color: T2, mb: "4px", fontWeight: 500 }}>To</Typography>
                                <TextField type="date" fullWidth size="small" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} sx={inputSx} />
                            </Box>
                        </Box>
                    </Box>

                    {/* Client Selection */}
                    <Box>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, mb: "6px", textTransform: "uppercase", letterSpacing: ".5px" }}>
                            Clients &nbsp;
                            <Typography component="span" sx={{ fontSize: 11, color: T2, fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>
                                ({tempSelectedClients.length} of {allClients.length} selected)
                            </Typography>
                        </Typography>
                        <TextField fullWidth size="small" placeholder="Search clients…" value={tempClientSearchText}
                            onChange={(e) => setTempClientSearchText(e.target.value)} sx={{ ...inputSx, mb: 1 }}
                            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: T3, fontSize: 16 }} /> }} />
                        <Box sx={{ border: `1px solid ${BORDER}`, borderRadius: "4px", overflow: "hidden", maxHeight: 220, overflowY: "auto" }}>
                            {/* Select All header */}
                            <Box sx={{ display: "flex", alignItems: "center", px: 1.5, py: "7px", background: TH_BG, borderBottom: `1px solid ${BORDER}`, position: "sticky", top: 0, zIndex: 1 }}>
                                <Checkbox size="small"
                                    checked={tempSelectedClients.length === filteredTempClients.length && filteredTempClients.length > 0}
                                    indeterminate={tempSelectedClients.length > 0 && tempSelectedClients.length < filteredTempClients.length}
                                    onChange={() => {
                                        if (tempSelectedClients.length === filteredTempClients.length) setTempSelectedClients([]);
                                        else setTempSelectedClients([...tempSelectedClients, ...filteredTempClients.filter(c => !tempSelectedClients.some(s => s.id === c.id))]);
                                    }}
                                    sx={{ color: T3, "&.Mui-checked": { color: STEEL }, "&.MuiCheckbox-indeterminate": { color: STEEL }, p: "3px" }} />
                                <Typography sx={{ fontSize: 12, fontWeight: 600, color: T2 }}>Select All ({filteredTempClients.length})</Typography>
                            </Box>
                            {filteredTempClients.length === 0 ? (
                                <Box sx={{ py: 3, textAlign: "center" }}>
                                    <Typography sx={{ fontSize: 13, color: T3 }}>No clients found</Typography>
                                </Box>
                            ) : filteredTempClients.map((client) => {
                                const isSelected = tempSelectedClients.some(c => c.id === client.id);
                                return (
                                    <Box key={client.id} onClick={() => handleTempClientCheckbox(client)}
                                        sx={{ display: "flex", alignItems: "center", px: 1.5, py: "6px", cursor: "pointer", borderBottom: `1px solid ${BORDER}`, background: isSelected ? STEEL_LT : WHITE, "&:hover": { background: STEEL_LT } }}>
                                        <Checkbox size="small" checked={isSelected} onChange={() => handleTempClientCheckbox(client)} onClick={(e) => e.stopPropagation()}
                                            sx={{ color: BORDER, "&.Mui-checked": { color: STEEL }, p: "3px", mr: 0.5 }} />
                                        <Typography sx={{ fontSize: 13, color: T1, fontWeight: isSelected ? 600 : 400 }}>{client.FirmName}</Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 2.5, py: 2, gap: 1, borderTop: `1px solid ${BORDER}`, background: TH_BG }}>
                <Button onClick={onClose} fullWidth sx={{ ...btnGhost, height: 34 }}>Cancel</Button>
                <Button onClick={onGetData} fullWidth disabled={loading || tempSelectedClients.length === 0}
                    startIcon={loading ? <CircularProgress size={13} sx={{ color: WHITE }} /> : <SearchIcon sx={{ fontSize: 15 }} />}
                    sx={{ ...btnPrimary, height: 34 }}>
                    Generate Report
                </Button>
            </DialogActions>
        </Dialog>
    );
}
